if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.updateMedia();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
 $(".template-product-configure variant-selects .variations .product-form__input--block").each(function () {
        var originalText = $(this).find(".form__label__value").text();
        $(this).find("label[data-option-name]").hover(
            function () {
                var newText = $(this).attr("title");
                $(this).closest(".product-form__input--block").find(".form__label__value").text(newText);
            },
            function () {
                $(this).closest(".product-form__input--block").find(".form__label__value").text(originalText);
            }
        );
    });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
        element.style.display = "none";
      });

      this.productSlider.querySelectorAll('[data-variant="'+this.currentVariant.id+'"]').forEach((element) => {
        element.style.display = "block";
      });
      // return true;
      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      //activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
    }

        updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;      
        const url = new URL(this.dataset.url, window.location.origin);
        const params = new URLSearchParams(window.location.search);      
        console.log(url,"url------")
        params.delete('variant');      
        const newParams = new URLSearchParams();
        newParams.set('variant', this.currentVariant.id);      
        params.forEach((value, key) => {
          newParams.append(key, value);
        });      
        window.history.replaceState({}, '', `${url.pathname}?${newParams.toString()}`);
   }

    // updateURL() {
    //   if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    //   window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    // }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);


      console.log(this.hideVariants);
      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

////////////custom code//////////

select_shape = "Oval";
use_2carat_image = true;
var apply_spcyo_function_dt = false;
var is_tacori = '';
no_ui_split_new = {
    2: "",
    3: "<ol class='ui-slider-two'><li class='fore1'></li></ol>",
    4: "<ol class='ui-slider-three'><li class='fore1'></li><li class='fore2'></li></ol>",
    5: "<ol class='ui-slider-four'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li></ol>",
    6: "<ol class='ui-slider-five'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li></ol>",
    7: "<ol class='ui-slider-six'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li></ol>",
    8: "<ol class='ui-slider-seven'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li><li class='fore6'></li></ol>",
    9: "<ol class='ui-slider-eight'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li><li class='fore6'></li><li class='fore7'></li></ol>",
    10: "<ol class='ui-slider-nine'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li><li class='fore6'></li><li class='fore7'></li><li class='fore8'></li></ol>",
    11: "<ol class='ui-slider-ten'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li><li class='fore6'></li><li class='fore7'></li><li class='fore8'></li><li class='fore9'></li></ol>",
    12: "<ol class='ui-slider-eleven'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li><li class='fore6'></li><li class='fore7'></li><li class='fore8'></li><li class='fore9'></li><li class='fore10'></li></ol>",
    13: "<ol class='ui-slider-twelve'><li class='fore1'></li><li class='fore2'></li><li class='fore3'></li><li class='fore4'></li><li class='fore5'></li><li class='fore6'></li><li class='fore7'></li><li class='fore8'></li><li class='fore9'></li><li class='fore10'></li><li class='fore11'></li></ol>",

}
no_ui_range_new = {
    2: {
        'min': [0, 0.08],
        'max': 0.08
    },
    3: {
        'min': [0, 0.08],
        '50%': [0.08, 0.08],
        'max': 0.16
    },
    4: {
        'min': [0, 0.08],
        '33%': [0.08, 0.08],
        '66%': [0.16, 0.08],
        'max': 0.24
    },
    5: {
        'min': [0, 0.08],
        '25%': [0.08, 0.08],
        '50%': [0.16, 0.08],
        '75%': [0.24, 0.08],
        'max': 0.32
    },
    6: {
        'min': [0, 0.08],
        '20%': [0.08, 0.08],
        '40%': [0.16, 0.08],
        '60%': [0.24, 0.08],
        '80%': [0.32, 0.08],
        'max': 0.4
    },
    7: {
        'min': [0, 0.08],
        '16.66%': [0.08, 0.08],
        '33.32%': [0.16, 0.08],
        '49.97%': [0.24, 0.08],
        '66.66%': [0.32, 0.08],
        '83.32%': [0.4, 0.08],
        'max': 0.48
    },
    8: {
        'min': [0, 0.08],
        '14.28%': [0.08, 0.08],
        '28.57%': [0.16, 0.08],
        '42.85%': [0.24, 0.08],
        '57.14%': [0.32, 0.08],
        '71.42%': [0.4, 0.08],
        '85.71%': [0.48, 0.08],
        'max': 0.56
    },
    9: {
        'min': [0, 0.08],
        '12.50%': [0.08, 0.08],
        '25.00%': [0.16, 0.08],
        '37.50%': [0.24, 0.08],
        '50.00%': [0.32, 0.08],
        '62.50%': [0.4, 0.08],
        '75.00%': [0.48, 0.08],
        '87.50%': [0.56, 0.08],
        'max': 0.64
    },
    10 : {
        'min': [0, 0.08],
            '11.11%': [0.08, 0.08],
            '22.22%': [0.16, 0.08],
            '33.33%': [0.24, 0.08],
            '44.44%': [0.32, 0.08],
            '55.55%': [0.4, 0.08],
            '66.66%': [0.48, 0.08],
            '77.77%': [0.56, 0.08],
            '88.88%': [0.64, 0.08],
            'max': 0.72
    },
    11 : {
        'min': [0, 0.08],
        '10.00%': [0.08, 0.08],
        '20.00%': [0.16, 0.08],
        '30.00%': [0.24, 0.08],
        '40.00%': [0.32, 0.08],
        '50.00%': [0.4, 0.08],
        '60.00%': [0.48, 0.08],
        '70.00%': [0.56, 0.08],
        '80.00%': [0.64, 0.08],
        '90.00%': [0.72, 0.08],
        'max': 0.80
    },
    12 : {
        'min': [0, 0.08],
        '9.09%': [0.08, 0.08],
        '18.18%': [0.16, 0.08],
        '27.27%': [0.24, 0.08],
        '36.36%': [0.32, 0.08],
        '45.45%': [0.4, 0.08],
        '54.54%': [0.48, 0.08],
        '63.63%': [0.56, 0.08],
        '72.72%': [0.64, 0.08],
        '81.81%': [0.72, 0.08],
        '90.90%': [0.80, 0.08],
        'max': 0.88
    },
    13 : {
        'min': [0, 0.08],
        '8.33%': [0.08, 0.08],
        '16.66%': [0.16, 0.08],
        '25.00%': [0.24, 0.08],
        '33.33%': [0.32, 0.08],
        '41.66%': [0.4, 0.08],
        '50.00%': [0.48, 0.08],
        '58.33%': [0.56, 0.08],
        '66.66%': [0.64, 0.08],
        '75.00%': [0.72, 0.08],
        '83.33%': [0.80, 0.08],
        '91.66%': [0.88, 0.08],
        'max': 0.96
    },

}
noui_notches_new = {
    2: ['0.00', '0.08'],
    3: ['0.00', '0.08', '0.16'],
    4: ['0.00', '0.08', '0.16', '0.24'],
    5: ['0.00', '0.08', '0.16', '0.24', '0.32'],
    6: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40'],
    7: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48'],
    8: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48', '0.56'],
    9: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48', '0.56', '0.64'],
    10: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48', '0.56', '0.64', '0.72'],
    11: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48', '0.56', '0.64', '0.72', '0.80'],
    12: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48', '0.56', '0.64', '0.72', '0.80', '0.88'],
    13: ['0.00', '0.08', '0.16', '0.24', '0.32', '0.40', '0.48', '0.56', '0.64', '0.72', '0.80', '0.88', '0.96'],
}

function get_slider_value(carat, carat_range) {
    var index = carat_range.indexOf(carat);
    var length = carat_range.length;
    return parseFloat(noui_notches_new[length][index]);
}

class CaratImageSetModel {
    constructor(image_type, image_set, shape, default_carat) {
        this.shape = shape
        this.type = image_type;
        this.hand_mapping = {  //old image
            'hand_zo': 'zo',
            'hand_zi': 'zi'
        }
        if (image_type === 'top') {
            this.carat_range = image_set[0];
            this.image_set = image_set[1];
            for (let i= 1; i< 5; i++) {
                if (this.image_set[parseFloat(i).toFixed(1)]){
                    this.image_set[i] = this.image_set[parseFloat(i).toFixed(1)]
                    delete this.image_set[parseFloat(i).toFixed(1)]
                }
            }
        } else {
            this.carat_range = Object.keys(image_set).sort();
            this.image_set = image_set;
        }
        this.carat_range_length = this.carat_range.length;
        if (default_carat && this.carat_range.includes(default_carat)) {
            this.carat = default_carat
        } else {
            this.carat = CaratImageSetModel.get_default_carat(this.shape, this.carat_range);
        }
        if (this.type === 'hand_zo' || this.type === 'hand_zi' ) {
            this.active = this.image_set[this.carat][this.hand_mapping[this.type]]
        } else {
            this.active = this.image_set[this.carat]
        }
    }

    set_active(carat){
        if (this.image_set[carat]) {
            this.carat = carat
            if (this.type === 'hand_zo' || this.type === 'hand_zi' ) {
                this.active = this.image_set[carat][this.hand_mapping[this.type]]
            } else {
                this.active = this.image_set[carat]
            }

        }

    }

    static get_default_carat(shape, carat_range) {
        var default_image_carat = 0.75;
        if (use_2carat_image && carat_range.indexOf(2.0) !== -1) {
            default_image_carat = 2;
            return default_image_carat;
        }

        if (shape === 'Round' || shape === 'Oval' || shape === 'Marquise' || shape == 'Marquis') {
            if (carat_range.indexOf(0.75) === -1) {
                default_image_carat = carat_range[0]|| 0.75;
            } else {
                default_image_carat = 0.75;
            }
        } else {
            if (carat_range.indexOf(1.25) === -1) {
                default_image_carat = carat_range[0] || 1.25;
            } else {
                default_image_carat = 1.25;
            }
        }

        return default_image_carat;
    }


}

class ShapeImageSetModel {
    constructor(image_type, shape_range, image_set, default_shape) {
        this.shape_range = shape_range;
        this.image_set = image_set;
        this.type = image_type;
        this.shape = default_shape
        this.active = this.image_set[default_shape]
    }

    set_active(shape){
        if (this.image_set[shape]) {
            this.shape = shape
            let current_carat = CaratImageSetModel.get_default_carat(this.shape, []);
            if (this.active && this.active.carat){
                current_carat = this.active.carat;
            }

            this.active = this.image_set[shape]
            this.active.set_active(current_carat)

        }else {
            this.shape = shape
            this.active = null
        }

    }


}

class SliderController {
    constructor(default_shape, top_image_set, hand_image_set, side1_image_set, side2_image_set ) {
        this.carat_slider_div_id = 'carat_slider_div'
        this.carat_slider_id = 'carat_slider'
        this.default_shape = default_shape
        this.all_shape_image_sets = []
        this.top_shape_image_set = this.create_image_set_model('top', top_image_set)
        this.hand_shape_image_set = this.create_image_set_model('hand', hand_image_set)
        this.side1_shape_image_set = this.create_image_set_model('side1', side1_image_set)
        this.side2_shape_image_set = this.create_image_set_model('side2', side2_image_set)
        this.active = this.top_shape_image_set
        this.hand_type_list = ['hand', 'hand_zo', 'hand_zi']


    }

    load(){
        this.render();
        this.bind_events();
        this.change_carat_slider();


    }

    set_active_shape(shape){
        for (var i =0; i < this.all_shape_image_sets.length; i++){
            this.all_shape_image_sets[i].set_active(shape);
        }
    }

    set_active_carat(carat){
        for (var i =0; i < this.all_shape_image_sets.length; i++){
            this.all_shape_image_sets[i].active.set_active(carat);
        }
    }

    get_carat(){
        let slider_value = $('#' + this.carat_slider_id).val();
        if ( this.active.active.carat_range_length < 2 ) {
            return this.active.active.carat_range[0]
        }
        let index = noui_notches_new[this.active.active.carat_range_length].indexOf(slider_value);
        if (index === -1) {
            index = 0;
        }
        return this.active.active.carat_range[index]
    }

    get_carat_format_by_image(image_url) {
        let string_array =  image_url.split('_');
        let key = '';
        let carat_format_dict = {
            '33': '1/3', '50': '1/2', '75': '3/4', '1': '1',
            '125': '1 1/4',  '150': '1 1/2', '2': '2', '250': '2 1/2',
            '3': '3', '4': '4', '5': '5'
        }
        if (string_array.length >= 2) {
            key = string_array[string_array.length-2];
        }

        return carat_format_dict[key];
    }

    get_carat_format(carat){
        var carat_format_dict = {
            0.33: '1/3', 0.5: '1/2', 0.75: '3/4',
            1.0: '1', 1.25: '1 1/4', 1.5: '1 1/2',
            2.0: '2', 2.5: '2 1/2', 3.0: '3',
            4.0: '4', 5.0: '5'
        }
        if (carat === undefined) {
            carat = this.get_carat();
        }
        return carat_format_dict[carat] || carat;

    }

    create_image_set_model(type, image_set, default_carat) {
        let shape_obj = {}, shape_range = [];
        if (Object.keys(image_set).length === 0 ){
            return
        }
        for (var shape in image_set) {
            shape_obj[shape] = new CaratImageSetModel(type, image_set[shape], shape, default_carat)
            shape_range.push(shape)
        }
        let obj =  new ShapeImageSetModel(type, shape_range, shape_obj, this.default_shape)
        this.all_shape_image_sets.push(obj)
        return obj

    }

    render(){
        let $carat_slider_div = $('#' + this.carat_slider_div_id);
        if (! this.active || !this.active.active || this.active.active.carat_range_length === 0 ) {
            $carat_slider_div.hide();
            return 0;
        }
        let active_carat_image_set = this.active.active;
        let carat_range_length = active_carat_image_set.carat_range_length;
        let format_carat = this.get_carat_format(active_carat_image_set.carat)
        $("#image_text_var").html('<span class="carat-text">View with Carat Size: </span>' + format_carat + ' Carat').data('carat', format_carat);
        if (carat_range_length < 2) {
            $carat_slider_div.hide();
            return ;
        } else {
            $carat_slider_div.show();
        }

        let start = get_slider_value(parseFloat(active_carat_image_set.carat), active_carat_image_set.carat_range);

        $carat_slider_div.find('.min span').html(this.get_carat_format(active_carat_image_set.carat_range[0]) + ' c');
        $carat_slider_div.find('.max span').html(this.get_carat_format(active_carat_image_set.carat_range[carat_range_length-1])+ ' c');
        $('#'+ this.carat_slider_id).noUiSlider({
            range: no_ui_range_new[carat_range_length],
            tooltips: true,
            start: start
        })
        $carat_slider_div.find('.noUi-base').append(no_ui_split_new[carat_range_length]);

    }

    destroy(){
        let $carat_slider = $('#'+ this.carat_slider_id);
        if($carat_slider.noUiSlider){
            try {
                $carat_slider[0].destroy();
            } catch (e) {
                console.log(e)
            }

        }
    }

    reload(){
        this.destroy();
        this.render();
    }

    update_new_image(type, format_carat, new_image) {
      console.log('type',type)
      console.log('format_carat',format_carat)
      console.log('new_image',new_image)
        var type_mapping = {
            'top': 'top_lg',
            'side1': 'side_lg1',
            'side2': 'side_lg2',
        }
        if ( this.hand_type_list.includes(type) ){
            if (new_image && $('.skin-tone-image img.hand_ring_overlay').attr('src') !== new_image) {
                $('.skin-tone-image img.hand_ring_overlay').attr('src', new_image);
                $("[data-caption='hand_zo_slider']").find('.image-text').html("Shown <span style='text-transform:lowercase'>with</span> " + format_carat + " Carat Diamond <span style='text-transform: lowercase'>on</span> Size 6 Hand");
            }

        } else if( type_mapping[type] ) {
          
            let $data_caption = $("[data-caption='"+ type_mapping[type] +"']");

            if ( new_image && $data_caption.find('img').attr('src') !== new_image) {
                if (type === 'top') {
                    // clearTimeout(overlay_load);
                    // overlay_load = setTimeout('$(".carat-image").removeClass("loaded2")', 100);
                }
              console.log('ade')
              if(type == 'top'){
                console.log('inside top')
                // $('.thb-product-detail .product-images__slide.product-images__slide--image:not(.product-slide--full):visible').eq(0).find('img').attr('srcset', new_image)
              }else if(type == 'side1'){
                console.log('inside side1')
                // $('.thb-product-detail .product-images__slide.product-images__slide--image:not(.product-slide--full):visible').eq(1).find('img').attr('srcset', new_image)
              }else if(type == 'side2'){
                console.log('inside side2')
                console.log(new_image)
                // $('.thb-product-detail .product-images__slide.product-images__slide--image:not(.product-slide--full):visible').eq(2).find('img').attr('srcset', new_image)
              }
                $data_caption.find('img').attr('src', new_image)
                $data_caption.find('.image-text').html('Shown <span style="text-transform:lowercase">with</span> ' + format_carat + ' Carat Diamond');


            }
        }


    }

    change_carat_slider = event => {
        if(!this.active || !this.active.active || this.active.active.carat_range_length === 0 ) {
            return
        }
        var carat = this.get_carat();
        this.set_active_carat(carat);
        console.log('change carat' + carat)

        var format_carat = this.get_carat_format(carat);
        $("#image_text_var").html('<span class="carat-text">View with Carat Size: </span>' + format_carat + ' Carat').data('carat', format_carat);
        $('.text-beautiful span').text(format_carat);
      $("#min-euro-pdp").html(format_carat + ' Carat');
      $('#carat_slider_val').val(format_carat)
        $("#min-euro-pdp").appendTo("#carat_slider .noUi-handle-lower");
        $('#'+ this.carat_slider_id).data('carat', carat);
      console.log(this.all_shape_image_sets);
        for (var i =0; i < this.all_shape_image_sets.length; i++){
            this.update_new_image(this.all_shape_image_sets[i].type, format_carat, this.all_shape_image_sets[i].active.active)
        }

    }

    change_shape_option = event =>{
        let shape = $(event.currentTarget).data('shape');
        console.log(shape);
        this.set_active_shape(shape);

        try {
            $(event.currentTarget).siblings('.selected').removeClass('selected');
            $(event.currentTarget).addClass('selected');
            $('#shape-menu').find('span').eq(0).text(shape);
            $('#shape-menu').find('span').eq(1).attr('class', $(event.currentTarget).find('span').eq(1).attr('class'));
            $('selected_shape').text(shape);
            $('.ir309-shape-thumbnails.active').removeClass('active');
            $(event.currentTarget).find('.ir309-shape-thumbnails').addClass('active');
            if (apply_spcyo_function_dt && !is_tacori ) {
              check_display_center_diamond_part();
              update_info($('.ir309-shape-thumbnails.active'), $('.ir345-carats-select .active'));
            }
            // recommended for you
            var params = {product_id: product_id, shape: shape, diamond_dict: diamond_dict, is_mobile: is_mobile, template_name: template_name};
            if(typeof(has_recent_right) != undefined){
                params['has_recent_right'] = has_recent_right;
            }
            get_recommended_for_you_dt_cyo_ring(params);
        }
        catch(e) {
            console.log(e)
        }

        init_setting_video();

        if ( !this.top_shape_image_set || !this.top_shape_image_set.active ||  this.top_shape_image_set.active.carat_range_length < 2 ){
            let top_caption = 'top';
            if(use_2carat_image) {
                top_caption = 'top_2carat'
            }

            let top_origin_image = product_shape_images[shape][top_caption]['lg'];
            let top_format_carat = ''
            if (top_origin_image) {
                top_format_carat = this.get_carat_format_by_image(top_origin_image);
                if (top_format_carat) {
                    this.update_new_image('top', top_format_carat,  product_shape_images[shape][top_caption]['md'])
                }

            }
            if (this.side1_shape_image_set && this.side1_shape_image_set.active && this.side1_shape_image_set.active.active) {
                let side1_image = this.side1_shape_image_set.active.active;
                let format_carat = this.get_carat_format(this.side1_shape_image_set.active.carat);
                this.update_new_image('side1', format_carat,  side1_image)
            } else {
                let side1_image = product_shape_images[shape]['side1']['lg'];
                this.update_new_image('side1', top_format_carat,  side1_image)
            }

            if (this.side2_shape_image_set && this.side2_shape_image_set.active && this.side2_shape_image_set.active.active) {
                let side2_image = this.side2_shape_image_set.active.active;
                let format_carat = this.get_carat_format(this.side2_shape_image_set.active.carat);
                this.update_new_image('side2', format_carat,  side2_image)
            } else {
                let side2_image = product_shape_images[shape]['side2']['lg'];
                this.update_new_image('side2', top_format_carat,  side2_image)
            }
            this.reload();

        } else {
            this.reload();
            this.change_carat_slider();
        }

        save_cookie_cyo_shape(setting_category);
    }

    bind_events(){
        var self = this;
        if( this.active ){
            $('#'+ this.carat_slider_id).on('slide', self.change_carat_slider);
        }
        $('.shape-li')
            .on('click', self.change_shape_option)
            .hover(
                function(){
                    $('selected_shape').text($(this).data('shape'));
                },
                function(){
                    $('selected_shape').text($('.ir309-shape-thumbnails.active').data('shape'));
                }
            );

    }




}



class MobileSliderController extends SliderController {
    constructor(default_shape, top_image_set, hand_image_set, side1_image_set, side2_image_set){
        super(default_shape, top_image_set, hand_image_set, side1_image_set, side2_image_set);
    }

    render(){
        let status = super.render();
        if (status === 0) {
            return 0;
        }

        if ($('#carat_slider_div #min-euro-pdp').length === 0) {
            $('.shape-carat-noUiSlider').append('<div id="min-euro-pdp" class="nowrap"></div>');
        }
        var format_carat = this.get_carat_format(this.active.active.carat);
        $("#min-euro-pdp").html(format_carat);
        $("#min-euro-pdp").appendTo("#carat_slider .noUi-handle-lower");
        $("#image_text").html("Shown <span style='text-transform:lowercase'>with</span> " + format_carat + " Carat "+ this.active.shape +" Diamond");


    }

    update_new_image(type, format_carat, new_image) {
      console.log('type',type)
      console.log('format_carat',format_carat)
      console.log('new_image',new_image)
        if( type === 'top' ) {
            if (new_image && $('.carat-image img.hand_ring_overlay.img-responsive').attr('src') !== new_image) {
                // clearTimeout(overlay_load);
                overlay_load = setTimeout('$(".carat-image").removeClass("loaded2")', 100);
                $('.carat-image img.hand_ring_overlay.img-responsive').attr('src', new_image);
            }
        } else if(type === 'hand'){
            if ( new_image && $('.skin-tone-image-zm img.hand_ring_overlay.img-responsive').attr('src') !== new_image) {
                $('.skin-tone-image-zm img.hand_ring_overlay.img-responsive').attr('src', new_image);
            }
        } else if(type === 'side1'){
            if(new_image && $('.side1-image img.hand_ring_overlay.img-responsive').attr('src') !== new_image){
                $('.side1-image img.hand_ring_overlay.img-responsive').attr('src', new_image)
            }
        } else if (type === 'side2' ) {
            if(new_image && $('.side2-image img.hand_ring_overlay.img-responsive').attr('src') !== new_image){
                $('.side2-image img.hand_ring_overlay.img-responsive').attr('src', new_image)
            }
        }

    }

    change_shape_option = event =>{
        let shape = $(event.currentTarget).data('shape');
        console.log(shape);
        this.set_active_shape(shape);
        let top_caption = $('#product_thumb_images li a').eq(0).data('caption');
        let to_replace = [];
        try {
            $('.diamondshape-slick-mobile .shape-li a').removeClass('active');
            $(event.currentTarget).find('a').addClass('active');

            if (top_caption === 'top' || top_caption === 'top_2carat'){
                product_images[top_caption]['tn'] = product_shape_images[shape][top_caption]['tn'];
                product_images[top_caption]['md'] = product_shape_images[shape][top_caption]['md'];
                product_images[top_caption]['lg'] = product_shape_images[shape][top_caption]['lg'];
                product_images[top_caption]['data-zoomable'] = product_shape_images[shape][top_caption]['data-zoomable'];
                product_images[top_caption]['text_line'] = product_shape_images[shape][top_caption]['text_line'];
                to_replace.push(top_caption);
            }

            if(product_images['side1']){
                product_images['side1']['tn'] = product_shape_images[shape]['side1']['tn'];
                product_images['side1']['md'] = product_shape_images[shape]['side1']['md'];
                product_images['side1']['lg'] = product_shape_images[shape]['side1']['lg'];
                product_images['side1']['data-zoomable'] = product_shape_images[shape]['side2']['data-zoomable'];
                to_replace.push('side1')
            }
            if(product_images['side2']){
                product_images['side2']['tn'] = product_shape_images[shape]['side2']['tn'];
                product_images['side2']['md'] = product_shape_images[shape]['side2']['md'];
                product_images['side2']['lg'] = product_shape_images[shape]['side2']['lg'];
                product_images['side2']['data-zoomable'] = product_shape_images[shape]['side2']['data-zoomable'];
                to_replace.push('side2')
            }
            let flag = 0;
            for (let i=0; i<setting_images.length; i++) {
                let image = setting_images[i];
                for (let j=0; j < to_replace.length; j++) {
                    let caption = to_replace[j];
                    if (image['caption'] == caption) {
                        image['tn'] = product_shape_images[shape][caption]['tn'];
                        image['md'] = product_shape_images[shape][caption]['md'];
                        image['lg'] = product_shape_images[shape][caption]['lg'];
                        image['data-zoomable'] = product_shape_images[shape][caption]['data-zoomable'];
                        image['text_line'] = product_shape_images[shape][caption]['text_line'];
                        flag++;
                        break;
                    }
                }
                if (flag === to_replace.length) {
                    break;
                }
            }


            if ( !this.top_shape_image_set || !this.top_shape_image_set.active || this.top_shape_image_set.active.carat_range_length < 2 ){

                let top_origin_image = product_shape_images[shape][top_caption]['lg'];
                let top_format_carat = ''
                if (top_origin_image) {
                    top_format_carat = this.get_carat_format_by_image(top_origin_image);
                    if (top_format_carat) {
                        this.update_new_image('top', top_format_carat,  product_shape_images[shape][top_caption]['md'])
                    }

                }
                if (this.side1_shape_image_set && this.side1_shape_image_set.active && this.side1_shape_image_set.active.active) {
                    let side1_image = this.side1_shape_image_set.active.active;
                    let format_carat = this.get_carat_format(this.side1_shape_image_set.active.carat);
                    this.update_new_image('side1', format_carat,  side1_image)
                } else {
                    let side1_image = product_shape_images[shape]['side1']['lg'];
                    this.update_new_image('side1', top_format_carat,  side1_image)
                }

                if (this.side2_shape_image_set && this.side2_shape_image_set.active && this.side2_shape_image_set.active.active) {
                    let side2_image = this.side2_shape_image_set.active.active;
                    let format_carat = this.get_carat_format(this.side2_shape_image_set.active.carat);
                    this.update_new_image('side2', format_carat,  side2_image)
                } else {
                    let side2_image = product_shape_images[shape]['side2']['lg'];
                    this.update_new_image('side2', top_format_carat,  side2_image)
                }
            }
            if (apply_spcyo_function_dt && !is_tacori ) {
              check_display_center_diamond_part();
              update_info($('.shape-li .active'), $('.ir345-carats-select .active'));
            }
            // recommended for you
            var params = {product_id: product_id, shape: shape, diamond_dict: diamond_dict, is_mobile: is_mobile, template_name: template_name};
            if(typeof(has_recent_right) != undefined){
                params['has_recent_right'] = has_recent_right;
            }
            if (setting_category == 'CYO Rings' && is_mobile){
               get_recommended_for_you_tmp(params);
            }else{
               get_recommended_for_you(params);
            }
            // recommended matched sets
            var new_params = {group_upc: group_upc, can_be_previewed: can_be_previewed, metal_abbr: metal_abbr, active: active, select_shape: shape, recommended_matched_sets: recommended_matched_sets, diamond_dict: diamond_dict};
            get_recommended_matched_sets(new_params);
        }
        catch(e) {
            console.log(e)
        }
        save_cookie_cyo_shape(setting_category, shape);
        if (!is_wistia_video){
            if (product_video_dict[shape]){
                $('#product_video').removeClass('hidden');
                $('#product_video_thumb').parent().removeClass('hidden');
                $('#product_video iframe').data('video-inited', false);
            } else {
                $('#product_video').addClass('hidden');
                $('#product_video_thumb').parent().addClass('hidden');
            }
        }

        this.reload();
        this.change_carat_slider();
    }


    change_carat_slider = event => {
        if(!this.active || !this.active.active || this.active.active.carat_range_length === 0 ) {
            return
        }
        var carat = this.get_carat();
        this.set_active_carat(carat);
        $('#'+ this.carat_slider_id).data('carat', carat);
        var format_carat = this.get_carat_format(carat);
        $("#min-euro-pdp").html(format_carat);
        $("#min-euro-pdp").appendTo("#carat_slider .noUi-handle-lower");
        for (var i =0; i < this.all_shape_image_sets.length; i++) {
            this.update_new_image(this.all_shape_image_sets[i].type, format_carat, this.all_shape_image_sets[i].active.active)
        }
        var caption = $('.zoomThumbActive').data('caption');
        hand_skin_tone_image_text = "Shown <span style='text-transform:lowercase'>with</span> " + format_carat + " Carat "+ this.active.shape +" Diamond <span style='text-transform: lowercase'>on</span> Size 6 Hand";
        if (hand_thumb_caption_list.includes(caption) && hand_skin_tone_set){
            $('#image_text').html(hand_skin_tone_image_text);
        }else{
            $('#image_text').html('Shown <span style="text-transform:lowercase">with</span> ' + format_carat + ' Carat '+ this.active.shape +' Diamond');
        }

    }
}

var product_shape_images = {};
    
        product_shape_images['Asscher'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/86/d4/86d4a9196b34924bfc27f96d2f7506d8.png',
                "md": '//image.brilliantearth.com/media/cache/41/90/4190a2178fa2703a8aadea2f09598ab6.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/ZN/BE18959_yellow_Asscher_top_125_carat.png',
                "data-zoomable": 'False',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/f6/4e/f64e3b651d022dc94e9d374c68ce2dfa.png',
                "md": '//image.brilliantearth.com/media/cache/82/b8/82b81a1248e9b119b45c0281db4f378b.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/7Y/BE18959_yellow_Asscher_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/96/f1/96f109887a68a346274a5927964c8774.jpg',
                "md": '//image.brilliantearth.com/media/cache/07/27/0727260b21655ae1a6e1b95574392278.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/F2/BE18959_AS_125ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/28/02/280214601ecf83cd4489747114285de3.jpg',
                "md": '//image.brilliantearth.com/media/cache/33/2f/332fb3284fe94ce4243da4ec59bf9980.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/66/BE18959_AS_125ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    
        product_shape_images['Cushion'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/15/da/15da2ce54d81d852d15be27c83b497d3.png',
                "md": '//image.brilliantearth.com/media/cache/27/8f/278f3a569e8ca2b918d2741180272621.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/RX/BE18959_yellow_Cushion_top_125_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/25/6f/256fcb536bb3d8718e875aa4a4028c5d.png',
                "md": '//image.brilliantearth.com/media/cache/3c/59/3c59b96cca474ab55e693cdc9e1f3918.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/CN/BE18959_yellow_Cushion_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/79/ed/79eda92795b8135150b4f86aed383abd.jpg',
                "md": '//image.brilliantearth.com/media/cache/43/04/430478181d78c71a7279c74de0cc3d2d.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/CF/BE18959_CU_125ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/67/87/6787fe90e9206a6c8da11702fc31d79f.jpg',
                "md": '//image.brilliantearth.com/media/cache/21/83/21834eafe65d0ff3971110cc149591ee.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/E6/BE18959_CU_125ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    
        product_shape_images['Emerald'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/10/7d/107df411abb5f2353fb85832d34ddb66.png',
                "md": '//image.brilliantearth.com/media/cache/d0/d4/d0d483199768059d789d0ec40059a3a1.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/Q3/BE18959_yellow_Emerald_top_125_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/2b/9a/2b9a0b891fe61455b47786a7aaaab0b4.png',
                "md": '//image.brilliantearth.com/media/cache/49/fd/49fdb3745492901f3728d3d9b949861a.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/93/BE18959_yellow_Emerald_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/6d/82/6d829d263e8665ea0c07f4b11cca9529.jpg',
                "md": '//image.brilliantearth.com/media/cache/18/7a/187a8abe422e43fc4abe547b67c375bb.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/B6/BE18959_EM_125ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/3f/10/3f1025b9b784af0f08381d273b75988b.jpg',
                "md": '//image.brilliantearth.com/media/cache/fd/ee/fdeef13abdb6531e9cd175f1d7af1839.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/FA/BE18959_EM_125ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    
        product_shape_images['Oval'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/84/94/8494dac9171b96ac753a1a80b3d7dc80.png',
                "md": '//image.brilliantearth.com/media/cache/ce/29/ce2943deba52515dcc7fb3df4cbe2e4f.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/RP/BE18959_yellow_Oval_top_75_carat.png',
                "data-zoomable": 'False',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/a7/22/a722ccce1ed684d7db32f09ff7361238.png',
                "md": '//image.brilliantearth.com/media/cache/96/cb/96cb74de32eefabaf9053799dff2e70f.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/0Y/BE18959_yellow_Oval_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/73/c5/73c5596a3890d36e658e0027d441d392.jpg',
                "md": '//image.brilliantearth.com/media/cache/42/ed/42ed3b430791fc594bab11e5db119fbd.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/A2/BE18959_OV_75ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/92/5c/925c615abf152eab6264a5d51c2e4cad.jpg',
                "md": '//image.brilliantearth.com/media/cache/47/70/477080ac4b3fc263732859c49b8e6d51.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/21/BE18959_OV_75ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    
        product_shape_images['Princess'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/72/02/72023c6900f7fa032880f9d28e5f7f86.png',
                "md": '//image.brilliantearth.com/media/cache/e4/95/e495493a22eaaad74b1abaabec7ac488.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/ON/BE18959_yellow_Princess_top_125_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/8c/94/8c94272dc463fbeb953e9f492b01df80.png',
                "md": '//image.brilliantearth.com/media/cache/26/1b/261b38f73e7da166d10450b30713684f.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/L6/BE18959_yellow_Princess_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/f1/a8/f1a81884e80291c84faaf109397db0dc.jpg',
                "md": '//image.brilliantearth.com/media/cache/d0/aa/d0aae450c08b18f4e9be4881769c142b.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/BC/BE18959_PR_125ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/40/1b/401b028634706c92f8cfd4f075269652.jpg',
                "md": '//image.brilliantearth.com/media/cache/72/2c/722c2c5540047aed1cdb13029a1d979e.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/79/BE18959_PR_125ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    
        product_shape_images['Radiant'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/ff/07/ff0710107bd58b5df31c52bbee0165f5.png',
                "md": '//image.brilliantearth.com/media/cache/c7/ad/c7ad65b4e42445a439395e1fc923942b.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/FJ/BE18959_yellow_Radiant_top_125_carat.png',
                "data-zoomable": 'False',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/f9/f1/f9f1db266688a41e23b1f7e01e0e0095.png',
                "md": '//image.brilliantearth.com/media/cache/23/ad/23ad5e74bef266778b262476d492a11c.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/WS/BE18959_yellow_Radiant_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/31/32/31324f751dfa7338bbb9b5beeea47716.jpg',
                "md": '//image.brilliantearth.com/media/cache/ed/da/eddac6f5c7f5ec1f4c2de8e455cd4096.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/E3/BE18959_RA_125ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/d8/6d/d86d1aaed9c16c3895d1e9f762477ed9.jpg',
                "md": '//image.brilliantearth.com/media/cache/02/b7/02b7dcd5b948d32597cc247ba43294b2.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/DC/BE18959_RA_125ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    
        product_shape_images['Round'] = {
            "top": {
                "tn": '//image.brilliantearth.com/media/cache/9f/83/9f83b4b109bbfe671ee0a9cdddf405bb.png',
                "md": '//image.brilliantearth.com/media/cache/e6/f8/e6f8849dae3742d7634df92b6d4499d8.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/5A/BE18959_yellow_Round_top_75_carat.png',
                "data-zoomable": 'False',
                "text_line": '',
            },
            "top_2carat": {
                "tn": '//image.brilliantearth.com/media/cache/18/50/18504799ca62b7f556326c18744f0b6f.png',
                "md": '//image.brilliantearth.com/media/cache/85/66/8566688bcd4952dfdbecd36d39225a34.png',
                "lg": '//image.brilliantearth.com/media/diamond_ring_vto/56/BE18959_yellow_Round_top_2_carat.png',
                "data-zoomable": 'True',
                "text_line": '',
            },
            "side1": {
                "tn": '//image.brilliantearth.com/media/cache/4e/f8/4ef8bd71e47ffee9abb2d9bf6da08559.jpg',
                "md": '//image.brilliantearth.com/media/cache/a7/12/a7124d62817a62b3e05dfcc432715cd5.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/28/BE18959_RD_75ct_yellow_side1.jpg',
                "data-zoomable": 'True'
            },
            "side2": {
                "tn": '//image.brilliantearth.com/media/cache/91/f8/91f80c3a6e6a9ceaaf6c06cf41ce2ebc.jpg',
                "md": '//image.brilliantearth.com/media/cache/ab/41/ab41ff2644382a9d1581549fe417dc4a.jpg',
                "lg": '//image.brilliantearth.com/media/carat_image/02/BE18959_RD_75ct_yellow_side2.jpg',
                "data-zoomable": 'True'
            }
        };
    

    
    size_on_hand_images = {
        'caption': '',
        'tn': '//css.brilliantearth.com/static/imgProd/diamond-size-visualization/image-assets/New-Hand-Zoom.jpg',
        'md': '//css.brilliantearth.com/static/imgProd/diamond-size-visualization/image-assets/New-Hand-Zoom.jpg',
        'lg': '//css.brilliantearth.com/static/imgProd/diamond-size-visualization/image-assets/New-Hand-Zoom.jpg',
        'alt': 'Actual Diamond Size on Size 6 Hand',
        'description':'Actual Diamond Size on Size 6 Hand'
    };
var hand_skin_tone_set_value = {};

  
$(document).ready(function () {
        let scroll_val = "";
        var a = $('input[name="Diamond Shape"]:checked').val();
        console.log(a, "i am here");
        let b = $('input[name="Diamond Shape"]').parents('.variations').find('input[name="Metal"]:checked').val();
        console.log(b);
        var caratValueFromId = $("#image_text_var").text();
        console.log(caratValueFromId ,"abc")
        var match = caratValueFromId.match(/(\d+(\s+\d+\/\d+)?)\s*Carat/);

        if (match) {
            var extractedValue = match[1];
            console.log("Extracted Value:", extractedValue);
            var mixedNumber = extractedValue;
        
        	var parts = mixedNumber.split(' ');
        	var whole = parseInt(parts[0]);
        	var fraction = eval(parts[1]); // Using eval to evaluate the fractional part
        
        	var decimalValue = whole + fraction;
          
            if(decimalValue){
               scroll_val = decimalValue;
            }else{
               scroll_val = extractedValue;
            }
        
        	console.log("decimalValue",scroll_val);
        	} 
        var result = b + " / " + a;
        
        $('.abc[data-title="' + result + '"]').each(function () {
            var c = $(this).text().trim();
            if (c === "") {
              c = 'https://cdn.shopify.com/s/files/1/0814/5469/4700/files/BE18959_yellow_Round_hand_zo_1_carat_1.webp?v=1706604520';
            }else{
              c = $(this).text();
            }
            console.log('Image', c);
            var dataName = $(this).data('name');
             if(dataName == scroll_val){
               let imageUrl =  $(this).text();
                console.log(imageUrl,"hhhhhhh")
                if(imageUrl.trim() != ""){
                  $('.hand_ring_overlay').attr('src', imageUrl);
                }else{
                  $('.hand_ring_overlay').attr('src', 'https://cdn.shopify.com/s/files/1/0814/5469/4700/files/BE18959_yellow_Round_hand_zo_1_carat_1.webp?v=1706604520');
                }
             }
            console.log('Data Name', dataName);
            hand_skin_tone_set_value[dataName] = c;
        });
      console.log("image_0_5",hand_skin_tone_set_value[0.5]); 
      console.log("image_0_7_5",hand_skin_tone_set_value[0.75]);
      console.log("image_1_0",hand_skin_tone_set_value[1]);
      
      console.log("image_1_2_5",hand_skin_tone_set_value[1.25]); 
      console.log("image_1_5",hand_skin_tone_set_value[1.5]);
      console.log("image_2_0",hand_skin_tone_set_value[2]); 
      console.log("image_2_5",hand_skin_tone_set_value[2.5]);
      console.log("image_3_0",hand_skin_tone_set_value[3]); 
      console.log("image_4_0",hand_skin_tone_set_value[4]);
      console.log("image_5_0",hand_skin_tone_set_value[5]);
    
});

$('input[name="Metal"]').change(function () {
    var a = $('input[name="Metal"]:checked').val();
    console.log(a);

    var b = $(this).parents('.variations').find('input[name="Diamond Shape"]:checked').val();
    console.log(b);
  var caratValueFromId = $("#image_text_var").text();
        console.log(caratValueFromId ,"abc")
        var match = caratValueFromId.match(/(\d+(\s+\d+\/\d+)?)\s*Carat/);
  if (match) {
            var extractedValue = match[1];
            console.log("Extracted Value:", extractedValue);
            var mixedNumber = extractedValue;
        
        	var parts = mixedNumber.split(' ');
        	var whole = parseInt(parts[0]);
        	var fraction = eval(parts[1]); // Using eval to evaluate the fractional part
        
        	var decimalValue = whole + fraction;
          
            if(decimalValue){
               scroll_val = decimalValue;
            }else{
               scroll_val = extractedValue;
            }
        
        	console.log("decimalValue",scroll_val);
        	} 
    var result = a + " / " + b;
    $('.abc[data-title="' + result + '"]').each(function () {
        var c = $(this).text().trim();
            if (c === "") {
              c = 'https://cdn.shopify.com/s/files/1/0814/5469/4700/files/BE18959_yellow_Round_hand_zo_1_carat_1.webp?v=1706604520';
            }else{
              c = $(this).text();
            }
        var dataName = $(this).data('name');
      if(dataName == scroll_val){
               let imageUrl =  $(this).text();
                console.log(imageUrl,"hhhhhhh")
                if(imageUrl.trim() != ""){
                  $('.hand_ring_overlay').attr('src', imageUrl);
                }else{
                  $('.hand_ring_overlay').attr('src', 'https://cdn.shopify.com/s/files/1/0814/5469/4700/files/BE18959_yellow_Round_hand_zo_1_carat_1.webp?v=1706604520');
                }
             }
        console.log('Data Name', dataName);
        hand_skin_tone_set_value[dataName] = c;
    });
    console.log('Hand Skin Tone Set', hand_skin_tone_set_value);
});

$('input[name="Diamond Shape"]').change(function () {
     var a = $('input[name="Diamond Shape"]:checked').val();
    console.log(a ,"i am here");
    var b = $(this).parents('.variations').find('input[name="Metal"]:checked').val();
    console.log(b);
  var caratValueFromId = $("#image_text_var").text();
        console.log(caratValueFromId ,"abc")
        var match = caratValueFromId.match(/(\d+(\s+\d+\/\d+)?)\s*Carat/);
  if (match) {
            var extractedValue = match[1];
            console.log("Extracted Value:", extractedValue);
            var mixedNumber = extractedValue;
        
        	var parts = mixedNumber.split(' ');
        	var whole = parseInt(parts[0]);
        	var fraction = eval(parts[1]); // Using eval to evaluate the fractional part
        
        	var decimalValue = whole + fraction;
          
            if(decimalValue){
               scroll_val = decimalValue;
            }else{
               scroll_val = extractedValue;
            }
        
        	console.log("decimalValue",scroll_val);
        	} 

    var result = b + " / " + a;
    $('.abc[data-title="' + result + '"]').each(function () {
       var c = $(this).text().trim();
            if (c === "") {
              c = 'https://cdn.shopify.com/s/files/1/0814/5469/4700/files/BE18959_yellow_Round_hand_zo_1_carat_1.webp?v=1706604520';
            }else{
              c = $(this).text();
            }
        var dataName = $(this).data('name');
        console.log('Data Name', dataName);
       if(dataName == scroll_val){
               let imageUrl =  $(this).text();
                console.log(imageUrl,"hhhhhhh")
                if(imageUrl.trim() != ""){
                  $('.hand_ring_overlay').attr('src', imageUrl);
                }else{
                  $('.hand_ring_overlay').attr('src', 'https://cdn.shopify.com/s/files/1/0814/5469/4700/files/BE18959_yellow_Round_hand_zo_1_carat_1.webp?v=1706604520');
                }
             }
        hand_skin_tone_set_value[dataName] = c;
    });
    console.log('Hand Skin Tone Set', hand_skin_tone_set_value);
    console.log("sgfhasg1",hand_skin_tone_set_value[0.5]);
    console.log("sgfhasg2",hand_skin_tone_set_value[0.75]);
    console.log("sgfhasg3",hand_skin_tone_set_value[1]);
    console.log("sgfhasg4",hand_skin_tone_set_value[1.5]);
    console.log("sgfhasg5",hand_skin_tone_set_value[2]);
    console.log("sgfhasg6",hand_skin_tone_set_value[2.5]);
    console.log("sgfhasg7",hand_skin_tone_set_value[3]);
    console.log("sgfhasg8",hand_skin_tone_set_value[4]);
    console.log("sgfhasg9",hand_skin_tone_set_value[5]);
});
    var has_top_carat_image_set = false, has_hand_carat_image_set = false, side1_carat_image_set, side2_carat_image_set,
    has_side1_carat_slider, has_side2_carat_slider;

    
        side1_carat_image_set = {'Round': {1.0: '//image.brilliantearth.com/media/carat_image/54/BE18959_RD_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/E0/BE18959_RD_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/AD/BE18959_RD_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/CF/BE18959_RD_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/4A/BE18959_RD_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/38/BE18959_RD_500ct_yellow_side1.jpg'}, 'Radiant': {1.0: '//image.brilliantearth.com/media/carat_image/F6/BE18959_RA_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/6D/BE18959_RA_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/95/BE18959_RA_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/2A/BE18959_RA_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/E3/BE18959_RA_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/D0/BE18959_RA_500ct_yellow_side1.jpg'}, 'Princess': {1.0: '//image.brilliantearth.com/media/carat_image/2E/BE18959_PR_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/72/BE18959_PR_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/E3/BE18959_PR_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/69/BE18959_PR_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/D8/BE18959_PR_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/4E/BE18959_PR_500ct_yellow_side1.jpg'}, 'Oval': {1.0: '//image.brilliantearth.com/media/carat_image/A4/BE18959_OV_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/30/BE18959_OV_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/2C/BE18959_OV_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/42/BE18959_OV_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/79/BE18959_OV_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/8F/BE18959_OV_500ct_yellow_side1.jpg'}, 'Emerald': {1.0: '//image.brilliantearth.com/media/carat_image/F5/BE18959_EM_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/C3/BE18959_EM_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/1F/BE18959_EM_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/01/BE18959_EM_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/C0/BE18959_EM_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/D2/BE18959_EM_500ct_yellow_side1.jpg'}, 'Cushion': {1.0: '//image.brilliantearth.com/media/carat_image/58/BE18959_CU_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/06/BE18959_CU_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/B1/BE18959_CU_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/6E/BE18959_CU_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/84/BE18959_CU_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/0E/BE18959_CU_500ct_yellow_side1.jpg'}, 'Asscher': {1.0: '//image.brilliantearth.com/media/carat_image/30/BE18959_AS_100ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/83/BE18959_AS_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/FD/BE18959_AS_200ct_yellow_side1.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/0E/BE18959_AS_300ct_yellow_side1.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/20/BE18959_AS_400ct_yellow_side1.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/5F/BE18959_AS_500ct_yellow_side1.jpg'}};
        has_side1_carat_slider = true
    
    
        side2_carat_image_set = {'Round': {1.0: '//image.brilliantearth.com/media/carat_image/DE/BE18959_RD_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/C9/BE18959_RD_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/FB/BE18959_RD_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/28/BE18959_RD_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/5E/BE18959_RD_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/70/BE18959_RD_500ct_yellow_side2.jpg'}, 'Radiant': {1.0: '//image.brilliantearth.com/media/carat_image/0B/BE18959_RA_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/0D/BE18959_RA_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/9A/BE18959_RA_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/5E/BE18959_RA_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/FF/BE18959_RA_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/6E/BE18959_RA_500ct_yellow_side2.jpg'}, 'Princess': {1.0: '//image.brilliantearth.com/media/carat_image/AA/BE18959_PR_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/2E/BE18959_PR_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/D0/BE18959_PR_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/E4/BE18959_PR_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/32/BE18959_PR_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/50/BE18959_PR_500ct_yellow_side2.jpg'}, 'Oval': {1.0: '//image.brilliantearth.com/media/carat_image/1E/BE18959_OV_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/CC/BE18959_OV_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/30/BE18959_OV_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/77/BE18959_OV_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/5A/BE18959_OV_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/44/BE18959_OV_500ct_yellow_side2.jpg'}, 'Emerald': {1.0: '//image.brilliantearth.com/media/carat_image/CE/BE18959_EM_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/04/BE18959_EM_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/B6/BE18959_EM_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/B6/BE18959_EM_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/AB/BE18959_EM_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/D2/BE18959_EM_500ct_yellow_side2.jpg'}, 'Cushion': {1.0: '//image.brilliantearth.com/media/carat_image/B1/BE18959_CU_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/E2/BE18959_CU_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/42/BE18959_CU_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/C9/BE18959_CU_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/30/BE18959_CU_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/4A/BE18959_CU_500ct_yellow_side2.jpg'}, 'Asscher': {1.0: '//image.brilliantearth.com/media/carat_image/BA/BE18959_AS_100ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/DD/BE18959_AS_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/A1/BE18959_AS_200ct_yellow_side2.jpg', 3.0: '//image.brilliantearth.com/media/carat_image/65/BE18959_AS_300ct_yellow_side2.jpg', 4.0: '//image.brilliantearth.com/media/carat_image/1A/BE18959_AS_400ct_yellow_side2.jpg', 5.0: '//image.brilliantearth.com/media/carat_image/EE/BE18959_AS_500ct_yellow_side2.jpg'}};
        has_side2_carat_slider = true;
    

    
        var top_carat_image_set = {'Asscher': [[1.0, 1.5, 2.0, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/WP/BE18959_yellow_Asscher_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/2M/BE18959_yellow_Asscher_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/7Y/BE18959_yellow_Asscher_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/9G/BE18959_yellow_Asscher_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/AJ/BE18959_yellow_Asscher_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/5N/BE18959_yellow_Asscher_top_5_carat.png'}], 'Cushion': [[1.0, 1.5, 2.0, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/BU/BE18959_yellow_Cushion_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/GD/BE18959_yellow_Cushion_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/CN/BE18959_yellow_Cushion_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/H5/BE18959_yellow_Cushion_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/UT/BE18959_yellow_Cushion_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/CF/BE18959_yellow_Cushion_top_5_carat.png'}], 'Emerald': [[1.0, 1.5, 2.0, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/4N/BE18959_yellow_Emerald_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/PM/BE18959_yellow_Emerald_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/93/BE18959_yellow_Emerald_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/8K/BE18959_yellow_Emerald_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/SA/BE18959_yellow_Emerald_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/RM/BE18959_yellow_Emerald_top_5_carat.png'}], 'Oval': [[1.0, 1.5, 2.0, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/S0/BE18959_yellow_Oval_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/XB/BE18959_yellow_Oval_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/0Y/BE18959_yellow_Oval_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/HR/BE18959_yellow_Oval_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/6E/BE18959_yellow_Oval_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/5H/BE18959_yellow_Oval_top_5_carat.png'}], 'Princess': [[1.0, 1.5, 2.0, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/4N/BE18959_yellow_Princess_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/LQ/BE18959_yellow_Princess_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/L6/BE18959_yellow_Princess_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/HK/BE18959_yellow_Princess_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/UQ/BE18959_yellow_Princess_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/PL/BE18959_yellow_Princess_top_5_carat.png'}], 'Radiant': [[1.0, 1.5, 2.0, 2.5, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/Q0/BE18959_yellow_Radiant_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/NP/BE18959_yellow_Radiant_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/WS/BE18959_yellow_Radiant_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/1N/BE18959_yellow_Radiant_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/7N/BE18959_yellow_Radiant_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/MO/BE18959_yellow_Radiant_top_5_carat.png'}], 'Round': [[1.0, 1.5, 2.0, 3.0, 4.0, 5.0], {1.0: '//image.brilliantearth.com/media/diamond_ring_vto/I1/BE18959_yellow_Round_top_1_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/M2/BE18959_yellow_Round_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/56/BE18959_yellow_Round_top_2_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/VL/BE18959_yellow_Round_top_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/XU/BE18959_yellow_Round_top_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/RQ/BE18959_yellow_Round_top_5_carat.png'}]};
        has_top_carat_image_set = true;
    


        var hand_skin_tone_set = { 'Oval': hand_skin_tone_set_value};
        // var hand_skin_tone_set = {'Asscher': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/Y9/BE18959_yellow_Asscher_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/K9/BE18959_yellow_Asscher_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/M4/BE18959_yellow_Asscher_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/ZW/BE18959_yellow_Asscher_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/7M/BE18959_yellow_Asscher_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/DV/BE18959_yellow_Asscher_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/P2/BE18959_yellow_Asscher_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/Q2/BE18959_yellow_Asscher_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/OU/BE18959_yellow_Asscher_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/4H/BE18959_yellow_Asscher_hand_zo_5_carat.png'}, 'Cushion': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/BX/BE18959_yellow_Cushion_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/VX/BE18959_yellow_Cushion_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/CX/BE18959_yellow_Cushion_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/61/BE18959_yellow_Cushion_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/7M/BE18959_yellow_Cushion_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/4Y/BE18959_yellow_Cushion_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/3C/BE18959_yellow_Cushion_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/DN/BE18959_yellow_Cushion_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/CP/BE18959_yellow_Cushion_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/OJ/BE18959_yellow_Cushion_hand_zo_5_carat.png'}, 'Emerald': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/BG/BE18959_yellow_Emerald_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/EU/BE18959_yellow_Emerald_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/9N/BE18959_yellow_Emerald_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/C1/BE18959_yellow_Emerald_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/H2/BE18959_yellow_Emerald_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/W5/BE18959_yellow_Emerald_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/PA/BE18959_yellow_Emerald_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/3Q/BE18959_yellow_Emerald_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/E3/BE18959_yellow_Emerald_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/SA/BE18959_yellow_Emerald_hand_zo_5_carat.png'}, 'Oval': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/UD/BE18959_yellow_Oval_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/DX/BE18959_yellow_Oval_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/PF/BE18959_yellow_Oval_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/FY/BE18959_yellow_Oval_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/PL/BE18959_yellow_Oval_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/XC/BE18959_yellow_Oval_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/LV/BE18959_yellow_Oval_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/39/BE18959_yellow_Oval_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/DH/BE18959_yellow_Oval_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/GY/BE18959_yellow_Oval_hand_zo_5_carat.png'}, 'Princess': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/9B/BE18959_yellow_Princess_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/A0/BE18959_yellow_Princess_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/GP/BE18959_yellow_Princess_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/HN/BE18959_yellow_Princess_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/6Z/BE18959_yellow_Princess_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/0Q/BE18959_yellow_Princess_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/8B/BE18959_yellow_Princess_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/ZR/BE18959_yellow_Princess_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/Y2/BE18959_yellow_Princess_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/HS/BE18959_yellow_Princess_hand_zo_5_carat.png'}, 'Radiant': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/B5/BE18959_yellow_Radiant_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/TB/BE18959_yellow_Radiant_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/VS/BE18959_yellow_Radiant_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/RE/BE18959_yellow_Radiant_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/UV/BE18959_yellow_Radiant_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/XQ/BE18959_yellow_Radiant_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/PU/BE18959_yellow_Radiant_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/57/BE18959_yellow_Radiant_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/SK/BE18959_yellow_Radiant_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/WQ/BE18959_yellow_Radiant_hand_zo_5_carat.png'}, 'Round': {0.5: '//image.brilliantearth.com/media/diamond_ring_vto/HB/BE18959_yellow_Round_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/C8/BE18959_yellow_Round_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/A4/BE18959_yellow_Round_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/IN/BE18959_yellow_Round_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/YC/BE18959_yellow_Round_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/NF/BE18959_yellow_Round_hand_zo_2_carat.png', 2.5: '//image.brilliantearth.com/media/diamond_ring_vto/MQ/BE18959_yellow_Round_hand_zo_250_carat.png', 3.0: '//image.brilliantearth.com/media/diamond_ring_vto/JA/BE18959_yellow_Round_hand_zo_3_carat.png', 4.0: '//image.brilliantearth.com/media/diamond_ring_vto/OH/BE18959_yellow_Round_hand_zo_4_carat.png', 5.0: '//image.brilliantearth.com/media/diamond_ring_vto/WA/BE18959_yellow_Round_hand_zo_5_carat.png'}};
        has_hand_carat_image_set = true;
    

    
      hand_skin_tone = false;
    

    var current_caption = 'top';
    var is_setting_video = false;
    
      var is_setting_video = true;
    
    var is_wistia_video = false;

// var top_carat_image_set = {'Round': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/S3/BE1D032_yellow_Asscher_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/SH/BE1D032_yellow_Asscher_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/TQ/BE1D032_yellow_Asscher_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/12/BE1D032_yellow_Asscher_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/DZ/BE1D032_yellow_Asscher_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/41/BE1D032_yellow_Asscher_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/MZ/BE1D032_yellow_Asscher_top_2_carat.png'}], 'Cushion': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/HB/BE1D032_yellow_Cushion_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/KX/BE1D032_yellow_Cushion_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/Y7/BE1D032_yellow_Cushion_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/4A/BE1D032_yellow_Cushion_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/4H/BE1D032_yellow_Cushion_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/6Q/BE1D032_yellow_Cushion_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/I0/BE1D032_yellow_Cushion_top_2_carat.png'}], 'Emerald': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/O3/BE1D032_yellow_Emerald_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/FP/BE1D032_yellow_Emerald_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/ZN/BE1D032_yellow_Emerald_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/2X/BE1D032_yellow_Emerald_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/E3/BE1D032_yellow_Emerald_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/TQ/BE1D032_yellow_Emerald_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/GY/BE1D032_yellow_Emerald_top_2_carat.png'}], 'Marquise': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/IC/BE1D032_yellow_Marquise_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/2T/BE1D032_yellow_Marquise_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/1C/BE1D032_yellow_Marquise_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/24/BE1D032_yellow_Marquise_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/SE/BE1D032_yellow_Marquise_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/V8/BE1D032_yellow_Marquise_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/GJ/BE1D032_yellow_Marquise_top_2_carat.png'}], 'Oval': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/3T/BE1D032_yellow_Oval_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/OJ/BE1D032_yellow_Oval_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/8J/BE1D032_yellow_Oval_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/ZK/BE1D032_yellow_Oval_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/JS/BE1D032_yellow_Oval_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/LF/BE1D032_yellow_Oval_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/G1/BE1D032_yellow_Oval_top_2_carat.png'}], 'Pear': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/S7/BE1D032_yellow_Pear_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/91/BE1D032_yellow_Pear_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/R0/BE1D032_yellow_Pear_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/MV/BE1D032_yellow_Pear_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/21/BE1D032_yellow_Pear_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/N0/BE1D032_yellow_Pear_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/92/BE1D032_yellow_Pear_top_2_carat.png'}], 'Princess': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/NC/BE1D032_yellow_Princess_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/MH/BE1D032_yellow_Princess_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/AQ/BE1D032_yellow_Princess_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/Y6/BE1D032_yellow_Princess_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/GJ/BE1D032_yellow_Princess_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/NY/BE1D032_yellow_Princess_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/LN/BE1D032_yellow_Princess_top_2_carat.png'}], 'Radiant': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/63/BE1D032_yellow_Radiant_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/MB/BE1D032_yellow_Radiant_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/0P/BE1D032_yellow_Radiant_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/BG/BE1D032_yellow_Radiant_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/JH/BE1D032_yellow_Radiant_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/HJ/BE1D032_yellow_Radiant_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/Y1/BE1D032_yellow_Radiant_top_2_carat.png'}], 'Round': [[0.33, 0.5, 0.75, 1.0, 1.25, 1.5, 2.0], {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/GV/BE1D032_yellow_Round_top_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/JV/BE1D032_yellow_Round_top_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/F7/BE1D032_yellow_Round_top_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/TZ/BE1D032_yellow_Round_top_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/VQ/BE1D032_yellow_Round_top_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/SY/BE1D032_yellow_Round_top_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/7Q/BE1D032_yellow_Round_top_2_carat.png'}]};
// var hand_skin_tone_set = {'Round': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/1J/BE1D032_yellow_Asscher_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/7Y/BE1D032_yellow_Asscher_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/RD/BE1D032_yellow_Asscher_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/TO/BE1D032_yellow_Asscher_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/MK/BE1D032_yellow_Asscher_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/DB/BE1D032_yellow_Asscher_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/PD/BE1D032_yellow_Asscher_hand_zo_2_carat.png'}, 'Cushion': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/4D/BE1D032_yellow_Cushion_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/UF/BE1D032_yellow_Cushion_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/UV/BE1D032_yellow_Cushion_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/A0/BE1D032_yellow_Cushion_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/NG/BE1D032_yellow_Cushion_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/P9/BE1D032_yellow_Cushion_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/NV/BE1D032_yellow_Cushion_hand_zo_2_carat.png'}, 'Emerald': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/45/BE1D032_yellow_Emerald_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/SY/BE1D032_yellow_Emerald_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/BG/BE1D032_yellow_Emerald_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/MI/BE1D032_yellow_Emerald_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/8S/BE1D032_yellow_Emerald_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/N0/BE1D032_yellow_Emerald_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/IO/BE1D032_yellow_Emerald_hand_zo_2_carat.png'}, 'Marquise': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/DH/BE1D032_yellow_Marquise_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/JM/BE1D032_yellow_Marquise_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/UG/BE1D032_yellow_Marquise_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/8R/BE1D032_yellow_Marquise_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/BL/BE1D032_yellow_Marquise_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/4A/BE1D032_yellow_Marquise_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/BT/BE1D032_yellow_Marquise_hand_zo_2_carat.png'}, 'Oval': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/ZL/BE1D032_yellow_Oval_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/ZU/BE1D032_yellow_Oval_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/9T/BE1D032_yellow_Oval_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/23/BE1D032_yellow_Oval_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/DM/BE1D032_yellow_Oval_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/N0/BE1D032_yellow_Oval_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/GD/BE1D032_yellow_Oval_hand_zo_2_carat.png'}, 'Pear': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/56/BE1D032_yellow_Pear_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/XO/BE1D032_yellow_Pear_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/G1/BE1D032_yellow_Pear_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/KE/BE1D032_yellow_Pear_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/OX/BE1D032_yellow_Pear_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/NB/BE1D032_yellow_Pear_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/PO/BE1D032_yellow_Pear_hand_zo_2_carat.png'}, 'Princess': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/NZ/BE1D032_yellow_Princess_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/42/BE1D032_yellow_Princess_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/GN/BE1D032_yellow_Princess_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/I9/BE1D032_yellow_Princess_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/7P/BE1D032_yellow_Princess_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/7R/BE1D032_yellow_Princess_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/PJ/BE1D032_yellow_Princess_hand_zo_2_carat.png'}, 'Radiant': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/9A/BE1D032_yellow_Radiant_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/5A/BE1D032_yellow_Radiant_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/0I/BE1D032_yellow_Radiant_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/LO/BE1D032_yellow_Radiant_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/18/BE1D032_yellow_Radiant_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/PU/BE1D032_yellow_Radiant_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/KT/BE1D032_yellow_Radiant_hand_zo_2_carat.png'}, 'Round': {0.33: '//image.brilliantearth.com/media/diamond_ring_vto/VP/BE1D032_yellow_Round_hand_zo_33_carat.png', 0.5: '//image.brilliantearth.com/media/diamond_ring_vto/JC/BE1D032_yellow_Round_hand_zo_50_carat.png', 0.75: '//image.brilliantearth.com/media/diamond_ring_vto/M1/BE1D032_yellow_Round_hand_zo_75_carat.png', 1.0: '//image.brilliantearth.com/media/diamond_ring_vto/TG/BE1D032_yellow_Round_hand_zo_1_carat.png', 1.25: '//image.brilliantearth.com/media/diamond_ring_vto/X1/BE1D032_yellow_Round_hand_zo_125_carat.png', 1.5: '//image.brilliantearth.com/media/diamond_ring_vto/T9/BE1D032_yellow_Round_hand_zo_150_carat.png', 2.0: '//image.brilliantearth.com/media/diamond_ring_vto/2E/BE1D032_yellow_Round_hand_zo_2_carat.png'}};
// var side1_carat_image_set = {'Round': {0.33: '//image.brilliantearth.com/media/carat_image/78/BE1D032_RD_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/6B/BE1D032_RD_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/1A/BE1D032_RD_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/6D/BE1D032_RD_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/35/BE1D032_RD_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/93/BE1D032_RD_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/19/BE1D032_RD_200ct_yellow_side1.jpg'}, 'Radiant': {0.33: '//image.brilliantearth.com/media/carat_image/8C/BE1D032_RA_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/66/BE1D032_RA_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/BE/BE1D032_RA_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/39/BE1D032_RA_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/92/BE1D032_RA_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/71/BE1D032_RA_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/40/BE1D032_RA_200ct_yellow_side1.jpg'}, 'Princess': {0.33: '//image.brilliantearth.com/media/carat_image/4C/BE1D032_PC_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/E2/BE1D032_PC_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/6E/BE1D032_PC_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/72/BE1D032_PC_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/EF/BE1D032_PC_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/08/BE1D032_PC_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/1E/BE1D032_PC_200ct_yellow_side1.jpg'}, 'Pear': {0.33: '//image.brilliantearth.com/media/carat_image/74/BE1D032_PS_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/BC/BE1D032_PS_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/4A/BE1D032_PS_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/35/BE1D032_PS_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/7D/BE1D032_PS_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/D3/BE1D032_PS_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/19/BE1D032_PS_200ct_yellow_side1.jpg'}, 'Oval': {0.33: '//image.brilliantearth.com/media/carat_image/E7/BE1D032_OV_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/22/BE1D032_OV_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/C3/BE1D032_OV_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/51/BE1D032_OV_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/CF/BE1D032_OV_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/5D/BE1D032_OV_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/F6/BE1D032_OV_200ct_yellow_side1.jpg'}, 'Marquise': {0.33: '//image.brilliantearth.com/media/carat_image/26/BE1D032_MQ_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/F9/BE1D032_MQ_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/5E/BE1D032_MQ_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/69/BE1D032_MQ_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/00/BE1D032_MQ_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/7D/BE1D032_MQ_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/56/BE1D032_MQ_200ct_yellow_side1.jpg'}, 'Emerald': {0.33: '//image.brilliantearth.com/media/carat_image/E4/BE1D032_EM_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/8F/BE1D032_EM_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/89/BE1D032_EM_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/86/BE1D032_EM_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/40/BE1D032_EM_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/2C/BE1D032_EM_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/69/BE1D032_EM_200ct_yellow_side1.jpg'}, 'Cushion': {0.33: '//image.brilliantearth.com/media/carat_image/B5/BE1D032_CU_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/5E/BE1D032_CU_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/5F/BE1D032_CU_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/89/BE1D032_CU_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/F5/BE1D032_CU_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/5D/BE1D032_CU_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/7A/BE1D032_CU_200ct_yellow_side1.jpg'}, 'Asscher': {0.33: '//image.brilliantearth.com/media/carat_image/27/BE1D032_AS_33ct_yellow_side1.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/38/BE1D032_AS_50ct_yellow_side1.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/84/BE1D032_AS_75ct_yellow_side1.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/82/BE1D032_AS_100ct_yellow_side1.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/8F/BE1D032_AS_125ct_yellow_side1.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/5F/BE1D032_AS_150ct_yellow_side1.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/F2/BE1D032_AS_200ct_yellow_side1.jpg'}};
// var side2_carat_image_set = {'Round': {0.33: '//image.brilliantearth.com/media/carat_image/A4/BE1D032_RD_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/8A/BE1D032_RD_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/A4/BE1D032_RD_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/5D/BE1D032_RD_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/CC/BE1D032_RD_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/DE/BE1D032_RD_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/DB/BE1D032_RD_200ct_yellow_side2.jpg'}, 'Radiant': {0.33: '//image.brilliantearth.com/media/carat_image/45/BE1D032_RA_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/29/BE1D032_RA_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/85/BE1D032_RA_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/AE/BE1D032_RA_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/5D/BE1D032_RA_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/0E/BE1D032_RA_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/E6/BE1D032_RA_200ct_yellow_side2.jpg'}, 'Princess': {0.33: '//image.brilliantearth.com/media/carat_image/D1/BE1D032_PC_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/0E/BE1D032_PC_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/3A/BE1D032_PC_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/5B/BE1D032_PC_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/9B/BE1D032_PC_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/91/BE1D032_PC_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/26/BE1D032_PC_200ct_yellow_side2.jpg'}, 'Pear': {0.33: '//image.brilliantearth.com/media/carat_image/95/BE1D032_PS_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/68/BE1D032_PS_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/49/BE1D032_PS_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/92/BE1D032_PS_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/F2/BE1D032_PS_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/5A/BE1D032_PS_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/EE/BE1D032_PS_200ct_yellow_side2.jpg'}, 'Oval': {0.33: '//image.brilliantearth.com/media/carat_image/83/BE1D032_OV_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/9E/BE1D032_OV_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/4E/BE1D032_OV_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/2B/BE1D032_OV_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/76/BE1D032_OV_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/01/BE1D032_OV_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/48/BE1D032_OV_200ct_yellow_side2.jpg'}, 'Marquise': {0.33: '//image.brilliantearth.com/media/carat_image/19/BE1D032_MQ_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/F4/BE1D032_MQ_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/6D/BE1D032_MQ_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/BC/BE1D032_MQ_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/01/BE1D032_MQ_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/10/BE1D032_MQ_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/44/BE1D032_MQ_200ct_yellow_side2.jpg'}, 'Emerald': {0.33: '//image.brilliantearth.com/media/carat_image/FE/BE1D032_EM_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/43/BE1D032_EM_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/4D/BE1D032_EM_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/EE/BE1D032_EM_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/D8/BE1D032_EM_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/35/BE1D032_EM_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/A6/BE1D032_EM_200ct_yellow_side2.jpg'}, 'Cushion': {0.33: '//image.brilliantearth.com/media/carat_image/2C/BE1D032_CU_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/9E/BE1D032_CU_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/C1/BE1D032_CU_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/59/BE1D032_CU_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/44/BE1D032_CU_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/11/BE1D032_CU_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/B4/BE1D032_CU_200ct_yellow_side2.jpg'}, 'Asscher': {0.33: '//image.brilliantearth.com/media/carat_image/04/BE1D032_AS_33ct_yellow_side2.jpg', 0.5: '//image.brilliantearth.com/media/carat_image/27/BE1D032_AS_50ct_yellow_side2.jpg', 0.75: '//image.brilliantearth.com/media/carat_image/04/BE1D032_AS_75ct_yellow_side2.jpg', 1.0: '//image.brilliantearth.com/media/carat_image/FB/BE1D032_AS_100ct_yellow_side2.jpg', 1.25: '//image.brilliantearth.com/media/carat_image/E1/BE1D032_AS_125ct_yellow_side2.jpg', 1.5: '//image.brilliantearth.com/media/carat_image/5D/BE1D032_AS_150ct_yellow_side2.jpg', 2.0: '//image.brilliantearth.com/media/carat_image/4C/BE1D032_AS_200ct_yellow_side2.jpg'}};
 
